import {TableCell, TableCellProps, TableHead, TableRow, Typography} from "@mui/material";
import {FormattedMessage, MessageDescriptor} from "react-intl";
import * as React from "react";

type Cell = {
    label?: MessageDescriptor;
    props?: TableCellProps;
    renderer?: React.ComponentType<object>;
};

type Props = {
    cells: Cell[];
};

const FormattedTableHead = ({cells}: Props) => (
    <TableHead>
        <TableRow>
            {cells.map((cell, idx) => (
                <TableCell key={idx} {...(cell?.props || {})}>
                    {cell.renderer ? (
                        React.createElement(cell.renderer)
                    ) : (
                        <Typography>{cell.label ? <FormattedMessage {...cell.label} /> : null}</Typography>
                    )}
                </TableCell>
            ))}
        </TableRow>
    </TableHead>
);

export default FormattedTableHead;
